export class CharacteristicValue {
    public id: number = 0;
    public name?: string;
    public selected: boolean = false;

    get value(): number {
        return this.id;
    }

    get text(): string | undefined {
        return this.name;
    }

    constructor(json?: any) {
        if (!json) {
            return;
        }

        Object.assign(this, json);
    }

    public clone(): CharacteristicValue {
        const characteristicValue = new CharacteristicValue();

        characteristicValue.id = this.id;
        characteristicValue.name = this.name;
        characteristicValue.selected = this.selected;

        return characteristicValue;
    }
}
